<div class="planning-form-box">
    @if (this.trip()) {
        <div #planningBoxContainer class="planning-form-box__container">
            <div class="planning-form-box__options">
                <app-switcher
                        [selectedIndex]="selectedIndex"
                        [switcherConfig]="config"
                        (selectedSwitch)="handleDefaultViewSwitcher($event)"
                ></app-switcher>
                <p class="options-title options-title--mt">
                    <mat-icon [svgIcon]="eSvgIcons.LOCATION" matSuffix></mat-icon>
                    Where does your trip start and end?
                </p>
                <div class="options-box">
                    @if (defaultView) {
                        <div class="options-box__field">
                            <p class="options-box__field__label">Start at</p>
                            <mat-form-field subscriptSizing="dynamic">
                                <input matInput
                                       #startInInput
                                       placeholder="City, Country"
                                       (input)="inputChanged($event, searchQueryStartInChanged)"
                                       [matAutocomplete]="autoStartAt"
                                       [value]="trip().startingLabel"
                                       (click)="cleanSelection('starting', trip().startingLocationId)"
                                       (focusout)="inputFocusOut(autoStartAt, 'starting')"
                                />
                                <mat-icon [svgIcon]="eSvgIcons.LOCATION" matSuffix></mat-icon>
                                <mat-autocomplete #autoStartAt="matAutocomplete"
                                                  (opened)="setScrollBoxState()"
                                                  (closed)="setScrollBoxState(); panelClosed(autoStartAt, trip().startingLocationId, startInInput.value)"
                                                  (optionSelected)="optionSelected($event, 'starting')"
                                                  [displayWith]="displayWith">
                                    <div class="f-col">
                                        <div class="autocomplete-list">
                                            @for (destination of startInDestinationOptions$ | async; track destination) {
                                                @if (destination && destination.category) {
                                                    <mat-option class="error-option">
                                                        We currently don’t support this destination
                                                    </mat-option>
                                                } @else {
                                                    <mat-option [value]="destination">
                                                        {{ destination.label }}
                                                    </mat-option>
                                                }
                                            }
                                        </div>
                                    </div>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div class="options-box__field">
                            <p class="options-box__field__label">End at</p>
                            <mat-form-field subscriptSizing="dynamic">
                                <input id="end-in-input"
                                       matInput
                                       #endInput
                                       placeholder="City, Country"
                                       [matAutocomplete]="autoEndAt"
                                       [value]="trip().endingLabel"
                                       (input)="inputChanged($event, searchQueryEndInChanged, true)"
                                       (focusout)="inputFocusOut(autoEndAt, 'ending')"
                                />
                                <mat-icon [svgIcon]="eSvgIcons.LOCATION" matSuffix></mat-icon>
                                <mat-autocomplete #autoEndAt="matAutocomplete"
                                                  [displayWith]="displayWith"
                                                  (opened)="setScrollBoxState()"
                                                  (optionSelected)="optionSelected($event, 'ending')"
                                                  (closed)="setScrollBoxState(); panelClosed(autoEndAt, trip().endingLocationId, endInput.value)">
                                    <div class="f-col">
                                        <div class="autocomplete-list">
                                            @if (endInDestinationOptions$ | async; as destinations) {
                                                @if (!isDefaultEndInView) {
                                                    @for (dest of destinations; track dest) {
                                                        <mat-option [value]="dest">{{ dest.label }}</mat-option>
                                                    }
                                                } @else {
                                                    <mat-option [value]="{
                                                    country_id: this.trip().startingCountry,
                                                    isAttraction: undefined,
                                                    label: this.trip().startingLabel,
                                                    val: this.trip().startingLocationId
                                                    }">
                                                        {{ this.trip().startingLabel }}
                                                    </mat-option>
                                                    @if (endInDestinationOptions$ | async; as destinations) {
                                                        @if (filterByAirport(destinations, true); as filteredByAirport) {
                                                            <p class="autocomplete-option-separator">
                                                                Cities with international airports:
                                                            </p>
                                                            @for (dest of filteredByAirport; track dest) {
                                                                <mat-option [value]="dest">{{ dest.label }}</mat-option>
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        </div>
                                    </div>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    } @else {
                        <div class="options-box__field">
                            <p class="options-box__field__label">City</p>
                            <mat-form-field subscriptSizing="dynamic">
                                <input matInput
                                       #startInInput
                                       placeholder="Type city name"
                                       [value]="trip().cityInfo?.label"
                                       [matAutocomplete]="autoStartAt"
                                       (input)="inputChanged($event, searchQueryStartInChanged)"
                                       (click)="isInsideOverlay = true"
                                       (focusout)="isInsideOverlay = false"
                                />
                                <mat-autocomplete
                                    #autoStartAt="matAutocomplete"
                                    [displayWith]="displayWith"
                                    (optionSelected)="exploreCitySelected($event)"
                                >
                                    <div class="f-col">
                                        <div class="autocomplete-list">
                                            @for (destination of startInDestinationOptions$ | async; track destination) {
                                                @if (destination && destination.category) {
                                                    <mat-option class="error-option">
                                                        We currently don’t support this destination
                                                    </mat-option>
                                                } @else if (destination.url) {
                                                    <mat-option [value]="destination">
                                                        {{ destination.label }}
                                                    </mat-option>
                                                }
                                            }
                                        </div>
                                    </div>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    }
                </div>
            </div>
            <div class="planning-form-box__options">
                <div class="planning-form-box__info-box">
                    <p class="options-title">
                        <mat-icon [svgIcon]="eSvgIcons.CALENDAR" matSuffix></mat-icon>
                        When you want to go?
                    </p>
                    @if (planningFormView.dateRangeEmpty) {
                        <button matRipple
                                class="change-btn"
                                (click)="planningFormView.dateRangeEmpty = false">
                            Choose
                        </button>
                    }
                </div>
                @if (!planningFormView.dateRangeEmpty) {
                    <div class="options-box">
                        @if (!planningFormView.dateRangePreview) {
                            <app-date-range-setting
                                    [data]="dateRangeData"
                                    (payload)="dateRangePayloadHandler($event)"
                            ></app-date-range-setting>
                        } @else {
                            <div class="options-box__selected">
                                <p class="result-text">{{ planningFormView.dateRangeText }}</p>
                                <button matRipple
                                        class="change-btn"
                                        (click)="planningFormView.dateRangePreview = false">
                                    Change
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="planning-form-box__options">
                <p class="options-title" style="--ic-width-height: 24px">
                    <mat-icon [svgIcon]="eSvgIcons.PEOPLE" matSuffix></mat-icon>
                    With whom you want to go?
                </p>
                <div class="options-box">
                    <app-travelers-setting
                            [travelersConfig]="trip().rooms"
                            (payload)="travelersSettingsPayloadHandler($event)"
                    ></app-travelers-setting>
                </div>
            </div>
        </div>
    }
</div>
<div class="planning-form-submit-box">
    <button class="btn-default btn-green" (click)="submitPlanningForm()">Plan</button>
</div>
